export default __webpack_public_path__ + "static/media/113_mobile.1fda377d.jpg";